export default __webpack_public_path__ + "static/media/04_TEO.c8a637ff.png";